import Map from './map';
import doo from './doo';
import imp from './imp';
import mmp from './mmp';
import shd from './shd';
import w3c from './w3c';
import w3d from './w3d';
import w3e from './w3e';
import w3i from './w3i';
import w3o from './w3o';
import w3r from './w3r';
import w3s from './w3s';
import w3u from './w3u';
import wct from './wct';
import wpm from './wpm';
import wtg from './wtg';
import wts from './wts';
import unitsdoo from './unitsdoo';
import w3f from './w3f';

export default {
  Map,
  doo,
  imp,
  mmp,
  shd,
  w3c,
  w3d,
  w3e,
  w3i,
  w3o,
  w3r,
  w3s,
  w3u,
  wct,
  wpm,
  wtg,
  wts,
  unitsdoo,
  w3f,
};
